// API Configuration
const envBaseUrl = import.meta.env.VITE_API_BASE_URL;
const isBrowser = typeof window !== "undefined";
const isLocalhost = isBrowser && (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");

export const API_BASE_URL =
  envBaseUrl && (!envBaseUrl.includes("localhost") || isLocalhost)
    ? envBaseUrl
    : isLocalhost
      ? "http://localhost:8001"
      : "https://api.miasistentelegalia.com";

// Other configuration values can be added here
export const DEFAULT_LANGUAGE = "es";
export const DEFAULT_JURISDICTION = "Colombia";

// Supabase S3 Configuration for contract analysis
export const SUPABASE_S3_ACCESS_KEY_ID = "c19b1a09f64b8e5f5043d810aef2a2ee";
export const SUPABASE_S3_SECRET_ACCESS_KEY =
  "77aa5aa061949aa54752b3b34f21245bff4e4784c41495bc3fc3cfdcb2cd7617";
export const SUPABASE_S3_BUCKET = "contract-analisis-raw-files";
export const SUPABASE_S3_REGION = "us-east-1";
export const SUPABASE_S3_ENDPOINT =
  "https://luiiwyzjtkqnmnzqghoz.supabase.co/storage/v1/s3";
